import { datadogRum } from '@datadog/browser-rum';

export const initializeDataDogRUM = (
  { applicationId, clientToken },
  env: 'staging' | 'production' = 'staging',
): void => {
  if (datadogRum.getInitConfiguration()) {
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    env,
    site: 'datadoghq.com',
    service: 'bktools',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
};

export function setDataDogRUMUser(userId: string): void {
  if (!datadogRum.getInitConfiguration()) return;
  datadogRum.setUser({ id: userId });
}

export function setDataDogRUMContext(key: string, value: string): void {
  if (!datadogRum.getInitConfiguration()) return;
  datadogRum.setGlobalContextProperty(key, value);
}

export function addFeatureFlagEvaluation(key: string, value: unknown): void {
  if (!datadogRum.getInitConfiguration()) return;
  datadogRum.addFeatureFlagEvaluation(key, value);
}
